import React, { FC } from 'react';
import styled from '@emotion/styled';

const StyledRadioButton = styled.input`
  opacity: 0;
  visibility: hidden;
  display: none;
  box-sizing: border-box;
  &:checked + label {
    &::after {
      content: '';
      display: inline-block;
      background-color: #7ab800;
      position: absolute;
      width: 12px;
      height: 12px;
      left: 6px;
      top: 6px;
      border-radius: 50%;
      box-sizing: border-box;
    }
  }
  & + label {
    display: inline-flex;
    height: 24px;
    align-items: center;
    position: relative;
    color: #566072;
    font-size: 14px;
    box-sizing: border-box;
    &::after {
      display: none;
      box-sizing: border-box;
    }
    &::before {
      content: '';
      width: 24px;
      box-sizing: border-box;
      margin-right: 10px;
      height: 24px;
      border-radius: 50%;
      border: 2px #b5c1c9 solid;
      background-color: white;
      display: inline-block;
      position: relative;
      box-sizing: border-box;
    }
  }
`;

export const RadioButton: FC<React.HTMLProps<HTMLInputElement>> = props => {
  return <StyledRadioButton {...props} />;
};
